// EditarLista.jsx
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import { useParams, useNavigate } from 'react-router-dom';
import { RemoveCircleOutline, RemoveRedEye } from '@mui/icons-material';

const EditarLista = () => {
  const { id } = useParams();
  const [lista, setLista] = useState({});
  const [productos, setProductos] = useState([]);
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getListaprecio();
  }, []);


  async function getListaprecio(){
    const url = `${process.env.REACT_APP_SERVER_URL}/api/listaprecios/${localStorage.getItem('idcompany')}/${id}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    const data = await response.json();
    setLista(data);
    setProductos(JSON.parse(data.productos))
  }

  const handleChange = (field, value) => {
    setLista((prev) => ({ ...prev, [field]: value }));
  };

  const handleProductChange = (id, price) => {
    const updatedProductos = [...lista.productos];
    const index = updatedProductos.findIndex((p) => p.id === id);

    if (index > -1) {
      updatedProductos[index].precio = price;
    }

    setLista((prev) => ({ ...prev, productos: updatedProductos }));
  };

  const handleAddProduct = (id) => {
    if (lista.productos.find((p) => p.id === id)) return;
    const producto = productosDisponibles.find((p) => p.id === id);
    if (producto) {
      setLista((prev) => ({
        ...prev,
        productos: [...prev.productos, { ...producto, precio: '' }],
      }));
    }
  };

  const handleRemoveProduct = (id) => {
    setLista((prev) => ({
      ...prev,
      productos: prev.productos.filter((p) => p.id !== id),
    }));
  };

  return (
    <Paper sx={{ p: 4, maxWidth: 900, mx: 'auto', px:10,py:10,mt:10}}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        Editar lista de precios
      </Typography>

      <Box my={2}>
        <TextField
          placeholder="Nombre de la lista"
          fullWidth
          value={lista.label}
          onChange={(e) => handleChange('label', e.target.value)}
          sx={{ mb: 2 }}
        />

        <TextField
          fullWidth
          placeholder="Descripción"
          value={lista.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          sx={{ mb: 2 }}
        />

    

        {productos && productos.length > 0 && (
          <Box>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledCellHeader>Producto</StyledCellHeader>
                    <StyledCellHeader>Precio</StyledCellHeader>
                    <StyledCellHeader align="right">Acciones</StyledCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productos.map((producto) => (
                    <TableRow key={producto.id}>
                      <TableCell>{producto.nombre}</TableCell>
                      <TableCell>{producto.precio}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={()=>{navigate(`/logistica/productos/${producto.id}`)}}>
                          <RemoveRedEye sx={{fontSize:18}}/>
                        </IconButton>
                        <IconButton onClick={() => handleRemoveProduct(producto.id)}>
                          <RemoveCircleOutline sx={{fontSize:18,color:"red"}}/>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button variant="outlined" sx={{marginRight:5}} onClick={()=>{navigate(-1)}}>Cancelar</Button>   
          <Button onClick={()=>{}} variant="contained" sx={{fontWeight:"bold"}} color='primarybutton'>
            Guardar cambios
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default EditarLista;
